import { liveTicker } from '@/mocks/blackinfo';

export default function BreakingTicker() {
  const doubled = [...liveTicker, ...liveTicker];
  return (
    <section
      id="top"
      className="mx-auto mt-6 flex max-w-[1280px] flex-col gap-4 px-4 md:px-6 lg:mt-8 lg:flex-row lg:items-stretch"
    >
      {/* 快讯压顶更新条 */}
      <div className="flex w-full items-stretch overflow-hidden rounded-lg border border-stone-200 bg-white">
        <div className="flex shrink-0 items-center gap-2 border-r border-red-100 bg-red-50 px-3 py-2.5 sm:px-4">
          <span className="h-2 w-2 rounded-full bg-red-600 live-dot" />
          <span className="whitespace-nowrap text-xs font-bold text-red-600 sm:text-sm">快讯 LIVE</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track h-full items-center">
            {doubled.map((text, i) => (
              <a
                href="#today"
                key={i}
                className="flex shrink-0 items-center gap-2 px-5 py-2.5 text-sm text-stone-700 hover:text-stone-950"
              >
                <span className="text-red-300">{'>'}</span>
                <span className="whitespace-nowrap">{text}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* 更新入口条 */}
      <div className="flex shrink-0 items-center justify-between gap-4 rounded-lg border border-stone-200 bg-white px-4 py-2.5 lg:min-w-[260px]">
        <div className="flex items-center gap-2">
          <i className="ri-loader-4-line text-lg text-stone-400" />
          <span className="text-xs font-medium text-stone-500">
            最近更新
            <span className="mt-0.5 block font-semibold text-stone-800">11:03</span>
          </span>
        </div>
        <a
          href="#today"
          className="inline-flex items-center gap-1 rounded-full border border-stone-200 px-3 py-1 text-xs font-medium text-stone-600 whitespace-nowrap transition-colors hover:border-stone-300 hover:text-stone-950"
        >
          看新料 <i className="ri-arrow-right-line" />
        </a>
      </div>
    </section>
  );
}